import axios from 'axios';
//import router from '../router/index';




const state = { 
    status  :                "",
    errors   :               "",
    product : {
        pName:              "",
        pImages:            [],
        pCatagory:          "",
        pDescription:       ""
    }

};
const getters = {
    product:    state   =>  state.product
};

const actions = {

    async newProductPost({commit}, item) {
        commit("sub_new_product");;
        let config = {
            header: {
                'Content-Type' : 'maltipart/form-data'
            } 
        };
   
        try {
            let res =   "";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.post('/api/images/upload', item, config)
            }else {
                console.log("new product post called initiaed")
                res = await axios.post('http://localhost:5000/api/images/upload',  item, config);
            }
            if(res.data.success) {
                commit("product_post_success")
            }
            return res
        } catch (error) {
            commit("product_post_error", error)
        }
        
    },
    async upload_text({commit}, item) {
        commit("sub_new_product");;

        try {
            let res =   "";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.post('/api/images/upload_text', item)
            }else {
                res = await axios.post('http://localhost:5000/api/images/upload_text',  item);
            }
            if(res.data.success) {
                commit("product_post_success")
            }
            return res
        } catch (error) {
            commit("product_post_error", error)
        }
        
    },
    //update menu
    async updateMenu({commit}, item) {
        console.log("Updated menue infor")
        console.log(item)
        commit("sub_new_product");;
        // let config = {
        //     header: {
        //         'Content-Type' : 'maltipart/form-data'
        //     } 
        // };
   
        try {
            let res =   "";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.put('/api/images/update', item)
            }else {
                //console.log("new product post called initiaed")
                res = await axios.put('http://localhost:5000/api/images/update',  item);
            }
            if(res.data.success) {
                commit("product_post_success")
            }
            return res
        } catch (error) {
            commit("product_post_error", error)
        }
        
    },


    //update Text menu
    async updateTextMenu({commit}, item) {
        console.log("Updated menue infor")
        console.log(item)
        commit("sub_new_product");;
        try {
            let res =   "";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.put('/api/images/updateText', item)
            }else {
                //console.log("new product post called initiaed")
                res = await axios.put('http://localhost:5000/api/images/updateText',  item);
            }
            if(res.data.success) {
                commit("product_post_success")
            }
            return res
        } catch (error) {
            commit("product_post_error", error)
        }
        
    },
    

    //Update product image 
    updateImage({commit}, image) {
        commit("update_product_image", image);
    },
    updateName({commit}, pName) {
        commit("update_product_name", pName);
    }, 
    updateCatagory({commit}, pCatagory) {
        commit("update_product_catagory", pCatagory); 
    },
    updateDescription({commit}, pDescription) {
        commit("update_product_description", pDescription);
    },
    newProduct({commit}) {
        commit("create_new_prudct");
    }, 
    clearProductImage({commit}) {
        commit("clear_product_image");
    }, 
    
    async getUploads({commit}) {
        try {
            commit("upload_files")

            let res =   "";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/products/images')
            }else {
                res = await axios.get('http://localhost:5000/api/products/images')
            }
            return res;
            
        } catch (error) {
            commit("file_retrieval_error")
        }
    },
    async getAll({commit}) {
        try {
            commit("upload_files") 
            let res ="";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/images/all')
            } else {
                res = await axios.get('http://localhost:5000/api/images/all')
            }
            return res;
        } catch (error) {
            commit("file_retrieval_error")
        }
    },
    
    async getAllText({commit}) {
        try {
            commit("upload_files") 
            let res ="";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/images/allText')
            } else {
                res = await axios.get('http://localhost:5000/api/images/allText')
            }
            return res;
        } catch (error) {
            commit("file_retrieval_error")
        }
    },
    

    
    async getElectronics({commit}) {

        try {
            commit("upload_files") 
            let res ="";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/products/electronics')
            } else {
                res = await axios.get('http://localhost:5000/api/products/electronics')
            }
            return res;
        } catch (error) {
            commit("file_retrieval_error")
        }
    },
    async getBreakFastMenue({commit}) {
        try {
            let res ="";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/images/breakfast')
            } else {
                res = await axios.get('http://localhost:5000/api/images/breakfast')
            }
            return res;
        } catch (error) {
            commit('file_retrieval_error')
        }
    },
    async getlaunchMenue({commit}) {
        try {
            let res ="";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/images/launch')
            } else {
                res = await axios.get('http://localhost:5000/api/images/launch')
            }
            return res;
        } catch (error) {
            commit('file_retrieval_error')
        }
    },

    async getDinnerMenue({commit}) {
        try {
            let res ="";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.get('/api/images/dinner')
            } else {
                res = await axios.get('http://localhost:5000/api/images/dinner')
            }
            return res;
        } catch (error) {
            commit('file_retrieval_error')
        }
    }
};

const mutations = {
    file_retrieval_error(state) {
        state.status = "Files are being retrieved"
    },
    upload_files(state) {
        state.status = "Files are being retrieved"
    },
    product_post_error(state, error){
        state.errors    = error;
    },
    product_post_success(state) {
        state.status = "new product posted sucessfully"
    },
    sub_new_product(state) {
        state.status = "new product post"
    },
    update_product_image(state, image) {
        state.product.pImages.push(image);
    },
    update_product_name(state, pName) {
        state.product.pName = pName;
    },
    update_product_catagory(state, pCatagory) {
        state.product.pCatagory = pCatagory;
    },
    update_product_description(state, pDescription) {
        state.product.pDescription  = pDescription;
    },
    create_new_prudct(state) {
        state.product.pImages       =   [];
        state.product.pName         =   "";
        state.product.pCatagory     =   "";
        state.product.pDescription  =   "";
    },
    clear_product_image(state) {
        state.product.pImages =  [];
    }

};


export default {
    state, 
    getters, 
    actions,
    mutations
}